export function parallaxBg() {
    let $window = $(window);
    let $parallax = $(".parallax-bg");
    let winTop = 0;
    let itemTop = 0;

    $window.on("load scroll", function () {
        winTop = $window.scrollTop();

        $parallax.each(function () {
            let $this = $(this);
            let speed = $this.data("scroll-speed");
            itemTop = $this.offset().top;

            if (winTop + $window.innerHeight() > itemTop && winTop + $window.innerHeight() / 2 < itemTop + $window.innerHeight() + $window.innerHeight() / 2) {
                let parallaxDistance = Math.round((winTop - itemTop) / speed);

                if ($this.hasClass("down")) {
                    if ( parallaxDistance > 0) {
                        $this.css({
                            transform: "translate3d(" + parallaxDistance / 3 + "px," + parallaxDistance + "px, 1px)",
                        });
                    }
                } else {
                    $this.css({
                        transform: "translate3d(-" + parallaxDistance / 3 + "px," + parallaxDistance + "px, 1px)",
                    });
                }
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/parallaxBg.js